<template>
  <div class="ecpm-dashboard">
    <div class="header">
      <img src="/Logo.png" alt="ECPM数据" class="logo" />
    </div>

    <el-card class="search-section">
      <div class="search-row">
        <el-form :inline="true" size="small">
          <el-form-item label="游戏名称:">
            <el-select 
              v-model="selectedGame" 
              placeholder="选择或搜索游戏名称"
              filterable
              no-match-text="无匹配的游戏"
              no-data-text="暂无游戏数据"
            >
              <el-option
                v-for="game in gameNameList"
                :key="game"
                :label="game"
                :value="game"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择时间:">
            <el-date-picker
              v-model="selectedDate"
              type="date"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="username"
              placeholder="可搜索用户名"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="openId"
              placeholder="可搜索 Openid"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getECPMDate">查询</el-button>
            <el-button type="warning" @click="$router.push('/account-manage')" v-if="role === '0'">伙伴管理</el-button>
            <el-button type="danger" @click="quit">退出登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-row :gutter="20" class="stats-cards">
      <el-col :span="6">
        <el-card shadow="hover">
          <div class="stat-label">总ecpm:</div>
          <div class="stat-value">
            {{ ((totalEcpm / totalPV) * 1000).toFixed(2) }}
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover">
          <div class="stat-label">总收入:</div>
          <div class="stat-value">{{ totalEcpm }}元</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover">
          <div class="stat-label">曝光人数:</div>
          <div class="stat-value">{{ uniqueUserCount }}人</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover">
          <div class="stat-label">曝光pv:</div>
          <div class="stat-value">{{ totalPV }}次</div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 新增：刷新后的数据展示 -->
    <div class="refresh-data-wrapper" v-if="finalEcpm !== null || finalTotalIncome !== null || shareIncome !== null">
      <el-row :gutter="20" class="stats-cards stats-cards-refresh">
        <el-col :span="8">
          <el-card shadow="hover" class="refresh-card">
            <div class="stat-label">最终ecpm:</div>
            <div class="stat-value">{{ finalEcpm || '0' }}</div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card shadow="hover" class="refresh-card">
            <div class="stat-label">最终总收入:</div>
            <div class="stat-value">{{ finalTotalIncome ? finalTotalIncome + '元' : '0元' }}</div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card shadow="hover" class="refresh-card">
            <div class="stat-label">分成收入:</div>
            <div class="stat-value">{{ shareIncome ? shareIncome + '元' : '0元' }}</div>
          </el-card>
        </el-col>
      </el-row>
      
      <!-- 刷新按钮 - 仅在选择昨天日期时显示 -->
      <el-button 
        v-if="isYesterday"
        type="text" 
        :class="['refresh-btn-icon', { 'is-refreshing': isRefreshing }]"
        @click="handleRefresh"
        :disabled="isRefreshing"
        icon="el-icon-refresh"
        circle
      ></el-button>
    </div>

    <div
      class="data-section"
      v-loading="isLoading"
      element-loading-text="数据加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.9)"
    >
      <el-card class="data-table">
        <el-table :data="tableData" style="width: 100%" border stripe @sort-change="handleSortChange">
          <el-table-column
            prop="event_time"
            label="广告时间"
            min-width="180"
            sortable
            :sort-orders="['ascending', 'descending']"
            :default-sort="{prop: 'event_time', order: 'descending'}"
          ></el-table-column>
          <el-table-column
            prop="cost"
            label="广告收益"
            min-width="120"
            sortable
            :sort-orders="['ascending', 'descending']"
          >
            <template slot-scope="scope">
              <span :class="getcostClass(scope.row.cost)">{{
                scope.row.cost / 100000
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="open_id"
            label="用户标识"
            min-width="280"
          ></el-table-column>
          <el-table-column prop="aid" label="来源" min-width="100">
            <template slot-scope="scope">
              {{ getSourceLabel(scope.row.aid) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="username"
            label="用户名"
            min-width="120"
          ></el-table-column>
          <el-table-column prop="ip" label="IP" min-width="140"></el-table-column>
          <el-table-column
            prop="city"
            label="城市"
            min-width="140"
          ></el-table-column>
          <el-table-column
            prop="brand"
            label="手机品牌"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="model"
            label="手机型号"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="version"
            label="APP版本"
            min-width="100"
          ></el-table-column>
        </el-table>
      </el-card>
    </div>
  </div>
</template>

<script>
import http from "../api/http";
export default {
  name: "HelloWorld",
  data() {
    return {
      role: localStorage.getItem("role"),
      isLoading: false,
      isRefreshing: false,
      selectedGame: "",
      gameNameList: [],
      selectedDate: "",
      username: "",
      openId: null,
      // 从刷新接口获取的数据
      finalEcpm: null,
      finalTotalIncome: null,
      shareIncome: null,
      tableData: [
        {
          event_time: "2025-06-21 13:54:34",
          cost: "12.8603",
          open_id: "_000rtwDjjJHDiCpdIUSLXRFRM69szRFZ5Bm",
          source: "抖音",
          username: "武玉涛",
          ip: "113.5.161.84",
          city: "绥化市青冈县",
          brand: "Apple",
          model: "iPhone 11",
          version: "33.7.0",
        },
      ],
    };
  },
  computed: {
    totalEcpm() {
      return this.tableData
        .reduce((sum, item) => {
          const revenue = parseFloat(item.cost / 100000) || 0;
          return sum + revenue;
        }, 0)
        .toFixed(2);
    },
    uniqueUserCount() {
      const uniqueOpenIds = new Set(this.tableData.map((item) => item.open_id));
      return uniqueOpenIds.size;
    },
    totalPV() {
      return this.tableData.length;
    },
    todayDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    // 判断选择的日期是否是昨天
    isYesterday() {
      if (!this.selectedDate) {
        return false;
      }
      
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      
      const selectedDateObj = new Date(this.selectedDate);
      selectedDateObj.setHours(0, 0, 0, 0);
      
      return selectedDateObj.getTime() === yesterday.getTime();
    },
  },
  methods: {
    // 获取真实ECPM数据（最终ecpm、最终总收入、分成收入）
    async fetchRealEcpmData(showMessage = false) {
      if (!this.selectedGame || !this.selectedDate) {
        return;
      }

      try {
        const response = await http.get("/api/ecpm/realEcpmData", {
          params: {
            gameName: this.selectedGame,
            startDate: this.selectedDate,
            endDate: this.selectedDate
          },
          headers: {
            "token": `${localStorage.getItem("token")}`
          }
        });

        if (response.data && response.data.code === 1) {
          const data = response.data.data;
          
          if (data) {
            // 设置最终ecpm值
            this.finalEcpm = data.ecpm !== undefined && data.ecpm !== null 
              ? (typeof data.ecpm === 'number' ? data.ecpm.toFixed(2) : data.ecpm.toString()) 
              : "0";
            
            // 设置最终总收入（realCost字段）
            this.finalTotalIncome = data.realCost !== undefined && data.realCost !== null
              ? (typeof data.realCost === 'number' ? data.realCost.toFixed(2) : data.realCost.toString())
              : "0";
            
            // 设置分成收入（proportionCost字段）
            this.shareIncome = data.proportionCost !== undefined && data.proportionCost !== null
              ? (typeof data.proportionCost === 'number' ? data.proportionCost.toFixed(2) : data.proportionCost.toString())
              : "0";
            
            if (showMessage) {
              this.$message.success("刷新成功");
            }
          } else {
            this.finalEcpm = "0";
            this.finalTotalIncome = "0";
            this.shareIncome = "0";
          }
        }
      } catch (error) {
        // 静默失败，不显示错误信息
        this.finalEcpm = "0";
        this.finalTotalIncome = "0";
        this.shareIncome = "0";
      }
    },

    // 刷新按钮点击事件
    async handleRefresh() {
      if (!this.selectedGame) {
        this.$message.warning("请先选择游戏名称");
        return;
      }
      if (!this.selectedDate) {
        this.$message.warning("请先选择日期");
        return;
      }

      this.isRefreshing = true;
      
      try {
        // 先调用POST接口
        const response = await http.post("/api/ecpm/adData", {
          gameName: this.selectedGame,
          startDate: this.selectedDate,
          endDate: this.selectedDate
        }, {
          headers: {
            "token": `${localStorage.getItem("token")}`
          }
        });
        
        // 检查返回结果
        if (response.data && response.data.code === 1) {
          // 成功后获取真实ECPM数据
          await this.fetchRealEcpmData(true);
        } else {
          // 返回错误信息
          this.$message.error(response.data?.msg || "操作失败");
        }
      } catch (error) {
        this.$message.error("刷新失败，请稍后重试");
      } finally {
        this.isRefreshing = false;
      }
    },
    getSourceLabel(aid) {
      switch (aid) {
        case "2329":
          return "抖音极速版";
        case "1128":
          return "抖音";
        case "1112":
          return "火山";
        case "13":
          return "头条";
        case "35":
          return "头条极速版";
        default:
          return "未知来源";
      }
    },
    getcostClass(cost) {
      const value = cost / 100000;
      if (value >= 20) return "cost-high";
      if (value >= 10) return "cost-medium";
      if (value >= 5) return "cost-low";
      return "cost-normal";
    },
    // 获取ecpm数据
    async getECPMDate() {
      this.isLoading = true;  // 开始加载
      
      let queryOpenIds = [];
      
      // 如果用户名有值，先通过用户名获取openid列表
      if (this.username && this.username.trim() !== '') {
        try {
          const openIdRes = await http.get(`/api/user-info/openid?username=${encodeURIComponent(this.username)}`, {
            headers: {
              "token": `${localStorage.getItem("token")}`
            }
          });
          
          if (openIdRes.data && openIdRes.data.code === 1 && openIdRes.data.data && Array.isArray(openIdRes.data.data)) {
            // 提取所有openId
            queryOpenIds = openIdRes.data.data.map(item => item.openId).filter(openId => openId);
            
            if (queryOpenIds.length === 0) {
              this.$message.warning("未找到该用户名对应的有效openid");
              this.isLoading = false;
              return;
            }
          } else {
            this.$message.warning("未找到该用户名对应的openid");
            this.isLoading = false;
            return;
          }
        } catch (error) {
          this.$message.error("获取用户openid失败，请检查用户名是否正确");
          this.isLoading = false;
          return;
        }
      } else if (this.openId && this.openId.trim() !== '') {
        // 如果直接输入了openId，使用单个openId
        queryOpenIds = [this.openId.trim()];
      }
      
      // 如果有多个openId，逐个查询并合并结果
      if (queryOpenIds.length > 0) {
        await this.getMultipleECPMData(queryOpenIds);
      } else {
        // 没有openId筛选条件，查询所有数据
        await this.getSingleECPMData(null);
      }
    },

    // 查询单个ECPM数据
    async getSingleECPMData(openId) {
      try {
        const response = await http.post("/api/ecpm/selectECPMByNameAndDate", {
          "name": this.selectedGame,
          "openId": openId,
          "eventTime": this.selectedDate
        }, {
          headers: {
            "token": `${localStorage.getItem("token")}`
          }
        });
        
        this.processECPMResponse(response);
      } catch (error) {
        this.$message.error("数据加载失败，请稍后重试");
      } finally {
        this.isLoading = false;
      }
    },

    // 查询多个openId的ECPM数据并合并
    async getMultipleECPMData(openIds) {
      try {
        const promises = openIds.map(openId => 
          http.post("/api/ecpm/selectECPMByNameAndDate", {
            "name": this.selectedGame,
            "openId": openId,
            "eventTime": this.selectedDate
          }, {
            headers: {
              "token": `${localStorage.getItem("token")}`
            }
          })
        );
        
        const responses = await Promise.all(promises);
        
        // 合并所有响应的数据
        let allData = [];
        responses.forEach(response => {
          if (response.data && response.data.code === 1 && response.data.data) {
            allData = allData.concat(response.data.data);
          }
        });
        
        // 创建一个模拟的响应对象来复用现有的处理逻辑
        const combinedResponse = {
          data: {
            code: 1,
            data: allData
          }
        };
        
        this.processECPMResponse(combinedResponse);
      } catch (error) {
        this.$message.error("数据加载失败，请稍后重试");
      } finally {
        this.isLoading = false;
      }
    },

    // 处理ECPM响应数据的通用方法
    processECPMResponse(res) {
      // 检查返回的code是否为1
      if (res.data && res.data.code === 1) {
        // code为1表示成功，即使data为null也不报错
        const responseData = res.data.data || [];
        
        // 处理API返回的数据，添加模拟数据
        const mockData = {
          names: [
            "张伟",
            "王芳",
            "李娜",
            "刘洋",
            "陈明",
            "杨华",
            "赵静",
            "周鑫",
            "吴婷",
            "郑阳",
          ],
          cities: [
            "北京市朝阳区",
            "上海市浦东新区",
            "广州市天河区",
            "深圳市南山区",
            "杭州市西湖区",
          ],
          brands: ["Apple", "HUAWEI", "OPPO", "vivo", "Xiaomi"],
          models: {
            Apple: ["iPhone 14", "iPhone 13", "iPhone 12"],
            HUAWEI: ["P60 Pro", "Mate 60", "Nova 11"],
            OPPO: ["Find X6", "Reno 10", "K11"],
            vivo: ["X100", "V29", "Y78"],
            Xiaomi: ["14 Pro", "13T", "Redmi K70"],
          },
        };
        
        // 处理数据，如果responseData为空数组则tableData也为空数组
        this.tableData = responseData.map((record) => {
          // 确保open_id字段正确映射
          const openId = record.openId || record.open_id || '';
          
          // 生成模拟数据
          const randomBrand = mockData.brands[
            Math.floor(Math.random() * mockData.brands.length)
          ];
          
          return {
            ...record,
            event_time: record.eventTime,
            open_id: openId, // 确保使用openId
            username:
              mockData.names[
                Math.floor(Math.random() * mockData.names.length)
              ],
            ip: `${Math.floor(Math.random() * 255)}.${Math.floor(
              Math.random() * 255
            )}.${Math.floor(Math.random() * 255)}.${Math.floor(
              Math.random() * 255
            )}`,
            city: mockData.cities[
              Math.floor(Math.random() * mockData.cities.length)
            ],
            brand: randomBrand,
            model: mockData.models[randomBrand]?.[
              Math.floor(Math.random() * (mockData.models[randomBrand]?.length || 1))
            ] || 'Unknown Model',
            version: "33.7.0",
            source: record.aid
          };
        });
        
        // 默认按时间倒序排序
        this.tableData.sort((a, b) => {
          const timeA = new Date(a.event_time).getTime();
          const timeB = new Date(b.event_time).getTime();
          return timeB - timeA;
        });

        // 在数据加载完成后发送去重的openIds
        this.sendUniqueOpenIds();
        
        // 查询后也获取真实ECPM数据
        this.fetchRealEcpmData();
      } else {
        // code不为1时才显示错误信息
        this.$message.error(res.data?.msg || "数据加载失败，请稍后重试");
      }
    },

    // 发送去重后的openIds到服务器并处理返回的用户信息
    sendUniqueOpenIds() {
      // 获取去重后的openIds
      const uniqueOpenIds = [...new Set(this.tableData.map(item => item.open_id))];
      
      // 过滤掉空值
      const filteredOpenIds = uniqueOpenIds.filter(id => id && id.trim() !== '');
      
      if (filteredOpenIds.length === 0) {
        return;
      }
      
      // 发送到服务器
      http.post("/api/user-info/uniqueOpenIds", filteredOpenIds, {
        headers: {
          "token": `${localStorage.getItem("token")}`
        }
      })
      .then((res) => {
        // 处理返回的用户信息
        if (res.data && res.data.code === 1 && res.data.data) {
          this.updateTableDataWithUserInfo(res.data.data);
        }
      })
      .catch(() => {
        // 静默失败，保持现有的模拟数据
      });
    },

    // 根据返回的用户信息更新表格数据
    updateTableDataWithUserInfo(userInfoList) {
      if (!Array.isArray(userInfoList)) {
        return;
      }

      // 创建一个以openId为key的用户信息映射
      const userInfoMap = new Map();
      userInfoList.forEach(userInfo => {
        if (userInfo.openId) {
          userInfoMap.set(userInfo.openId, {
            username: userInfo.username || '',
            city: userInfo.city || '',
            brand: userInfo.phoneBrand || '',
            model: userInfo.phoneModel || '',
            version: userInfo.appVersion || '',
            ip: userInfo.ipAddress || ''
          });
        }
      });

      // 更新表格数据
      this.tableData = this.tableData.map(record => {
        const realUserInfo = userInfoMap.get(record.open_id);
        
        if (realUserInfo) {
          // 如果找到匹配的用户信息，替换模拟数据
          return {
            ...record,
            username: realUserInfo.username,
            city: realUserInfo.city,
            brand: realUserInfo.brand,
            model: realUserInfo.model,
            version: realUserInfo.version,
            ip: realUserInfo.ip
          };
        } else {
          // 如果没有找到匹配的信息，保持原有的模拟数据
          return record;
        }
      });
    },

    // 查询该用户账户下的游戏名称
    getGameName() {
      http.get("/api/userGames/getUserGames",
      {
        headers: {
          "token": `${localStorage.getItem("token")}`
        }
      }).then((res) => {
        // console.log(res.data.data);
        this.gameNameList = res.data.data.map((item) => item.gameName);
        // console.log(this.gameNameList);
        this.selectedGame = this.gameNameList[0];
        // 在获取到游戏列表并设置默认游戏后，再获取ECPM数据
        this.getECPMDate();
        // 初始化时也发送去重的openIds
        this.sendUniqueOpenIds();
        // 获取真实ECPM数据
        this.fetchRealEcpmData();
      }).catch(() => {
        this.$message.error("获取游戏列表失败");
      });
    },
    // 退出
    quit() {
      this.$router.push("/");
      localStorage.removeItem("token");
    },
    // 自定义广告收益排序方法
    sortByCost(a, b) {
      return (a.cost - b.cost) / 100000;
    },

    // 处理表格排序
    handleSortChange({ prop, order }) {
      if (prop === 'event_time') {
        this.tableData.sort((a, b) => {
          const timeA = new Date(a.event_time).getTime();
          const timeB = new Date(b.event_time).getTime();
          return order === 'ascending' ? timeA - timeB : timeB - timeA;
        });
      } else if (prop === 'cost') {
        this.tableData.sort((a, b) => {
          const costA = parseFloat(a.cost);
          const costB = parseFloat(b.cost);
          return order === 'ascending' ? costA - costB : costB - costA;
        });
      }
    },
  },
  mounted() {
    this.selectedDate = this.todayDate;
    this.getGameName();
  },
};
</script>

<style scoped>
.ecpm-dashboard {
  padding: 30px;
  background: linear-gradient(135deg, #f6f8fc 0%, #e9ecf4 100%);
  min-height: 100vh;
  box-sizing: border-box;
}

.header {
  text-align: center;
  margin-bottom: 30px;
  animation: fadeInDown 0.5s ease-out;
}

.logo {
  height: 70px;
  transition: transform 0.3s;
}

.logo:hover {
  transform: scale(1.05);
}

.search-section {
  margin-bottom: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  background: white;
  animation: fadeIn 0.5s ease-out;
}

.search-section :deep(.el-card__body) {
  padding: 25px;
}

.refresh-data-wrapper {
  position: relative;
  margin-bottom: 30px;
}

.refresh-btn-icon {
  position: absolute;
  top: -10px;
  right: -10px;
  font-size: 28px;
  color: #409EFF;
  transition: all 0.3s;
  padding: 10px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  z-index: 10;
}

.refresh-btn-icon:hover:not(:disabled) {
  color: #66b1ff;
  transform: scale(1.15);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.refresh-btn-icon.is-refreshing {
  animation: rotating 1s linear infinite;
  color: #409EFF;
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.search-row {
  display: flex;
  justify-content: center;
}

.search-row :deep(.el-form-item) {
  margin-bottom: 0;
  margin-right: 15px;
}

.search-row :deep(.el-input__inner),
.search-row :deep(.el-select),
.search-row :deep(.el-date-editor) {
  width: 200px;
  border-radius: 8px;
}

.search-row :deep(.el-button) {
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s;
}

.search-row :deep(.el-button:hover) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stats-cards {
  margin-bottom: 30px;
  animation: fadeIn 0.5s ease-out 0.2s backwards;
}

.stats-cards :deep(.el-card) {
  border-radius: 12px;
  transition: all 0.3s;
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: white;
  border: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.stats-cards :deep(.el-card:hover) {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

/* 刷新后的数据卡片样式 */
.stats-cards-refresh {
  animation: fadeIn 0.5s ease-out 0.3s backwards;
}

.stats-cards-refresh :deep(.refresh-card) {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
}

.stats-cards-refresh :deep(.refresh-card .stat-label) {
  color: rgba(255, 255, 255, 0.9);
}

.stats-cards-refresh :deep(.refresh-card .stat-value) {
  color: #ffffff;
  font-weight: 700;
}

.stat-label {
  color: #8c8c8c;
  font-size: 16px;
  margin-bottom: 12px;
  text-align: center;
}

.stat-value {
  font-size: 28px;
  color: #2c3e50;
  font-weight: 600;
  text-align: center;
}

.data-section {
  position: relative;
  min-height: 300px;
}

/* 自定义加载样式 */
.data-section :deep(.el-loading-mask) {
  border-radius: 12px;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(255, 255, 255, 0.98) 100%
  );
  backdrop-filter: blur(4px);
}

.data-section :deep(.el-loading-spinner) {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.data-section :deep(.el-loading-spinner i) {
  font-size: 30px;
  color: #409EFF;
  margin-bottom: 10px;
  animation: bounce 1.5s ease-in-out infinite;
}

.data-section :deep(.el-loading-text) {
  font-size: 16px;
  color: #409EFF;
  font-weight: 500;
}

/* 加载动画效果 */
@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.data-table {
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  background: white;
  animation: fadeIn 0.5s ease-out 0.4s backwards;
}

.data-table :deep(.el-card__body) {
  padding: 0;
}

.data-table :deep(.el-table) {
  border-radius: 12px;
  overflow: hidden;
}

.data-table :deep(.el-table th) {
  background-color: #f8fafc;
  color: #606266;
  font-weight: 600;
  padding: 15px 0;
}

.data-table :deep(.el-table td) {
  padding: 12px 0;
}

.data-table :deep(.el-table--striped .el-table__body tr.el-table__row--striped td) {
  background: #f8fafc;
}

.data-table :deep(.el-table__body tr:hover td) {
  background: #f0f2f5 !important;
}

.cost-high {
  color: white;
  background: linear-gradient(135deg, #ff4757 0%, #ff6b81 100%);
  padding: 6px 12px;
  border-radius: 20px;
  font-weight: 600;
  display: inline-block;
}

.cost-medium {
  color: white;
  background: linear-gradient(135deg, #1e90ff 0%, #70a1ff 100%);
  padding: 6px 12px;
  border-radius: 20px;
  font-weight: 600;
  display: inline-block;
}

.cost-low {
  color: white;
  background: linear-gradient(135deg, #2ed573 0%, #7bed9f 100%);
  padding: 6px 12px;
  border-radius: 20px;
  font-weight: 600;
  display: inline-block;
}

.cost-normal {
  color: #606266;
  background: #f0f2f5;
  padding: 6px 12px;
  border-radius: 20px;
  font-weight: 500;
  display: inline-block;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式布局 */
@media (max-width: 1200px) {
  .stats-cards :deep(.el-card) {
    margin-bottom: 20px;
  }

  .search-row {
    flex-wrap: wrap;
  }

  .search-row :deep(.el-form-item) {
    margin-bottom: 15px;
  }
}

@media (max-width: 768px) {
  .ecpm-dashboard {
    padding: 15px;
  }

  .search-row :deep(.el-input__inner),
  .search-row :deep(.el-select),
  .search-row :deep(.el-date-editor) {
    width: 100%;
  }

  .stats-cards :deep(.el-card) {
    height: 100px;
  }

  .stat-value {
    font-size: 24px;
  }
}

.data-table :deep(.el-table th.is-sortable) {
  cursor: pointer;
}

.data-table :deep(.el-table th.is-sortable:hover) {
  background-color: #eef2f8;
}

.data-table :deep(.el-table th.ascending .sort-caret.ascending) {
  border-bottom-color: #409EFF;
}

.data-table :deep(.el-table th.descending .sort-caret.descending) {
  border-top-color: #409EFF;
}
</style>
